var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { AppIcon } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';
import { Box, Chip, Typography } from '@mui/material';
import { ROIModalCard } from './ROIModalCard';
import { InfoModal } from '../InfoModal';
var ROI_LINE_CHART_STRINGS = appStrings.modules.charts.returnOnInvestment;
var getChipIcon = function (_a) {
    var total_roi = _a.total_roi, onClick = _a.onClick;
    var chipType = (function () {
        if (total_roi > 100)
            return 'veryGoodROI';
        if (total_roi > 0)
            return 'goodROI';
        return 'lowROI';
    })();
    return (_jsx(Chip, { variant: "badge", size: "md", type: "leading", label: ROI_LINE_CHART_STRINGS.modalCards[chipType].title, icon: _jsx(AppIcon, { iconName: chipType === 'lowROI' ? 'ThumbsDown' : 'ThumbsUp', diameter: "20px", color: ROI_LINE_CHART_STRINGS.modalCards[chipType].chipColor }), sx: chartChipSx, onClick: function () { return onClick(chipType); } }));
};
export var ROILineChartHeader = function (_a) {
    var total_roi = _a.total_roi;
    var _b = useState(false), isFullMuiDialogOpen = _b[0], setIsFullMuiDialogOpen = _b[1];
    var _c = useState(undefined), isIndividualModalOpen = _c[0], setIsIndividualModalOpen = _c[1];
    return (_jsxs(_Fragment, { children: [_jsx(InfoModal, { open: isFullMuiDialogOpen, onClose: function () { return setIsFullMuiDialogOpen(false); }, headerContent: _jsxs(Box, { children: [_jsx(Typography, { variant: "text-lg-semibold", color: function (_a) {
                                var backrs = _a.backrs;
                                return backrs.colors['Colors/Text/text-primary'];
                            }, children: ROI_LINE_CHART_STRINGS.explanationTitle }), _jsxs(Typography, { variant: "text-sm-regular", sx: headerContentTextSx, children: [ROI_LINE_CHART_STRINGS.explanationText.first, _jsx(Typography, { variant: "text-sm-bold", component: "span", children: ROI_LINE_CHART_STRINGS.explanationText.second }), ROI_LINE_CHART_STRINGS.explanationText.third] })] }), bodyContent: _jsx(Box, { sx: bodyContentSx, children: Object.values(ROI_LINE_CHART_STRINGS.modalCards).map(function (card) { return (_jsx(ROIModalCard, { title: card.title, chipLabel: card.chipLabel, chipColor: card.chipColor, iconName: card.iconName, cardDescriptions: card.cardDescription, leftCardContent: {
                            title: card.leftCardContent.title,
                            description: card.leftCardContent.description,
                        }, rightCardContent: {
                            title: card.rightCardContent.title,
                            description: card.rightCardContent.description,
                        } }, card.title)); }) }) }), _jsxs(Box, { sx: titleContentSx, children: [_jsxs(Box, { sx: titleSx, children: [_jsx(Typography, { variant: "text-lg-semibold", component: "div", children: ROI_LINE_CHART_STRINGS.title }), _jsx(Box, { sx: tooltipIconSx, onClick: function () { return setIsFullMuiDialogOpen(function (prev) { return !prev; }); }, children: _jsx(AppIcon, { iconName: "HelpCircle", diameter: "20px", color: "Colors/Foreground/fg-quinary" }) })] }), _jsxs(Box, { sx: totalInvestmentSx, children: [_jsxs(Typography, { variant: "display-sm-semibold", component: "div", children: [total_roi, "%"] }), getChipIcon({ total_roi: total_roi, onClick: setIsIndividualModalOpen }), isIndividualModalOpen && (_jsx(InfoModal, { open: !!isIndividualModalOpen, onClose: function () { return setIsIndividualModalOpen(undefined); }, width: "sm", bodyContent: _jsx(Box, { sx: bodyContentSx, children: _jsx(ROIModalCard, { isIndividualCard: true, iconName: ROI_LINE_CHART_STRINGS.modalCards[isIndividualModalOpen].iconName, title: ROI_LINE_CHART_STRINGS.modalCards[isIndividualModalOpen].title, chipLabel: ROI_LINE_CHART_STRINGS.modalCards[isIndividualModalOpen].chipLabel, chipColor: ROI_LINE_CHART_STRINGS.modalCards[isIndividualModalOpen].chipColor, cardDescriptions: ROI_LINE_CHART_STRINGS.modalCards[isIndividualModalOpen].cardDescription, leftCardContent: {
                                            title: ROI_LINE_CHART_STRINGS.modalCards[isIndividualModalOpen].leftCardContent
                                                .title,
                                            description: ROI_LINE_CHART_STRINGS.modalCards[isIndividualModalOpen].leftCardContent
                                                .description,
                                        }, rightCardContent: {
                                            title: ROI_LINE_CHART_STRINGS.modalCards[isIndividualModalOpen].rightCardContent
                                                .title,
                                            description: ROI_LINE_CHART_STRINGS.modalCards[isIndividualModalOpen].rightCardContent
                                                .description,
                                        } }, ROI_LINE_CHART_STRINGS.modalCards[isIndividualModalOpen].title) }) }))] })] })] }));
};
var titleContentSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        gap: backrs.spacing['spacing-md'],
    });
};
var totalInvestmentSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: backrs.spacing['spacing-lg'],
        mb: { xs: backrs.spacing['spacing-2xl'], sm: backrs.spacing['spacing-none'] },
    });
};
var titleSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        alignItems: { xs: 'flex-start', sm: 'center' },
        flexDirection: { xs: 'row', sm: 'row' },
        justifyContent: 'space-between',
        gap: backrs.spacing['spacing-sm'],
    });
};
var tooltipIconSx = {
    cursor: 'pointer',
};
var chartChipSx = function (_a) {
    var typography = _a.typography, backrs = _a.backrs;
    return ({
        border: "1px solid ".concat(backrs.colors['Colors/Border/border-primary']),
        cursor: 'pointer',
        '& .MuiChip-label': __assign({}, typography['text-lg-medium']),
    });
};
var bodyContentSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        gap: backrs.spacing['spacing-lg'],
    });
};
var headerContentTextSx = {
    whiteSpace: 'pre-line',
};
